import { useMemo } from 'react';

import { SortOption } from 'stores/marketPlaceStore';
import { useStores } from 'stores/rootStore';

export const allSortOptions: SortOption[] = [
  {
    label: 'Price: Low to High',
    id: 'price-low-to-high',
    dimensionId: 'price',
    direction: 'asc',
  },
  {
    label: 'Price: High to Low',
    id: 'price-high-to-low',
    dimensionId: 'price',
    direction: 'desc',
  },
  {
    label: 'None',
    id: 'none',
    dimensionId: 'price',
    direction: 'asc',
  },
];

export const useMarketPlaceSortOptions = () => {
  const { marketPlaceStore } = useStores();
  const selectedOption = useMemo(() => {
    return allSortOptions.find((option) => option.id === marketPlaceStore.sortBy);
  }, [marketPlaceStore.sortBy]);

  return { sortOptions: allSortOptions, selectedOption };
};
